// utils/jobsReportUtils.js

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generateJobsReport = (jobsData) => {
  return new Promise((resolve, reject) => {
    try {
      // Group jobs by shop
      const groupedJobs = jobsData.reduce((acc, job) => {
        const shopName = job.shop_name || 'Unknown';
        if (!acc[shopName]) {
          acc[shopName] = [];
        }
        acc[shopName].push(job);
        return acc;
      }, {});

      // Generate the PDF
      const doc = new jsPDF({ orientation: 'landscape' });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const primaryColor = '#384f77';
      const white = '#ffffff';
      const currentDate = new Date();

      // Header
      doc.setFillColor(white);
      doc.rect(0, 0, pageWidth, 20, 'F');
      doc.setFontSize(24);
      doc.setTextColor(primaryColor);
      doc.text('JOBS SUMMARY REPORT', pageWidth / 2, 14, { align: 'center' });

      // Company Information
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(12);
      doc.setTextColor(primaryColor);
      doc.setFont('helvetica', 'bold');
      doc.text('Advanced Controls & Automation', 15, 30);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(0, 0, 0);
      doc.text('574 Hudson River Road', 15, 36);
      doc.text('Waterford', 15, 42);
      doc.text('NY 12188', 15, 48);

      // Report Information
      doc.setFontSize(10);
      doc.setTextColor(primaryColor);
      doc.text(`Generated on: ${currentDate.toLocaleDateString()}`, 15, 60);
      
      let currentY = 70;

      // Generate tables for each shop
      Object.keys(groupedJobs).forEach((shopName, index) => {
        // Sort jobs by due date (oldest first, KANBAN jobs at end)
        const shopJobs = groupedJobs[shopName].sort((a, b) => {
          // Handle null/undefined dates (KANBAN jobs) - put them at the end
          if (!a.expected_delivery_date && !b.expected_delivery_date) return 0;
          if (!a.expected_delivery_date) return 1;
          if (!b.expected_delivery_date) return -1;
          
          // Compare actual dates
          return new Date(a.expected_delivery_date) - new Date(b.expected_delivery_date);
        });

        // Check if we need a new page (except for first shop)
        if (index > 0 && currentY > pageHeight - 150) {
          doc.addPage();
          currentY = 20;
        }

        // Shop Title
        doc.setFontSize(14);
        doc.setTextColor(primaryColor);
        doc.text(`${shopName}`, 15, currentY);
        currentY += 15;

        // Format data for the table
        const formattedJobsData = shopJobs.map(job => ({
          'PO': job.po_number,
          'Line': job.po_line_number,
          'Part#': job.part_number,
          'Description': job.description && job.description.length > 20 ? 
            job.description.slice(0, 20) + '...' : job.description || '',
          'Status': job.status.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase()),
          'Due Date': job.expected_delivery_date ? 
            new Date(job.expected_delivery_date).toLocaleDateString() : 'KANBAN',
          'Order Qty': job.quantity_on_order,
          'Produced': job.produced_quantity,
          'Shipped': job.shipped_quantity,
          'Remaining': job.remaining_quantity,
          'Inventory': job.inventory_quantity
        }));

        // Table Headers
        const headers = Object.keys(formattedJobsData[0]);
        
        // Generate table
        autoTable(doc, {
          startY: currentY,
          head: [headers],
          body: formattedJobsData.map(row => Object.values(row)),
          theme: 'grid',
          styles: { fontSize: 8, cellPadding: 2 },
          headStyles: { fillColor: primaryColor, textColor: white, fontStyle: 'bold' },
          alternateRowStyles: { fillColor: [240, 240, 240] },
          margin: { left: 15, right: 15 },
          didParseCell: (data) => {
            // Highlight overdue rows in red
            if (data.section === 'body') {
              const row = formattedJobsData[data.row.index];
              if (row && row['Due Date'] !== 'KANBAN' && 
                  new Date(row['Due Date']) < currentDate && 
                  !row['Status'].includes('Closed')) {
                data.cell.styles.fillColor = [255, 0, 0]; // Red highlight
                data.cell.styles.textColor = [255, 255, 255]; // White text for readability
              }
            }
          },
        });

        currentY = doc.lastAutoTable.finalY + 20;
      });

      // Save the PDF
      doc.save(`jobs_summary_report_${currentDate.toISOString().split('T')[0]}.pdf`);
      resolve(true);
    } catch (error) {
      console.error('Error generating Jobs PDF:', error);
      reject(error);
    }
  });
};